import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getOtherOptionsFromWindow } from "../../utils";
import { applyConsent } from "../applyConsent";
import { createTcfModelFromCookie, getUserDecision } from "@devowl-wp/cookie-consent-web-client";
import { getCookieConsentManager } from "..";
/**
 * When a content blocker needs to be unblocked (user click), then
 * we need to get the current consent, and add the newly consent cookies.
 */

function adjustConsentComingFromContentBlocker(_x) {
  return _adjustConsentComingFromContentBlocker.apply(this, arguments);
}

function _adjustConsentComingFromContentBlocker() {
  _adjustConsentComingFromContentBlocker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blocker) {
    var _getOtherOptionsFromW, essentialGroup, groups, isTcf, tcf, tcfMetadata, userConsentCookieName, blockerId, cookies, visualThumbnail, currentDecision, _groups$filter, _groups$filter2, essentialGroupObj, newConsent, _iterator, _step, _step$value, groupId, items, _iterator2, _step2, cookieId, _newConsent$groups$gr, tcfString, _createTcfModelFromCo;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Get all available groups + current decision
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), essentialGroup = _getOtherOptionsFromW.essentialGroup, groups = _getOtherOptionsFromW.groups, isTcf = _getOtherOptionsFromW.isTcf, tcf = _getOtherOptionsFromW.tcf, tcfMetadata = _getOtherOptionsFromW.tcfMetadata, userConsentCookieName = _getOtherOptionsFromW.userConsentCookieName;
            blockerId = blocker.id, cookies = blocker.cookies, visualThumbnail = blocker.visualThumbnail;
            currentDecision = getUserDecision(userConsentCookieName);
            _groups$filter = groups.filter(function (_ref) {
              var slug = _ref.slug;
              return slug === essentialGroup;
            }), _groups$filter2 = _slicedToArray(_groups$filter, 1), essentialGroupObj = _groups$filter2[0]; // Prepare new consent

            newConsent = currentDecision === false ? {
              // The website owner uses a banner without overlay and content gets unblocked
              // We need to make sure, that also essential cookies got accepted
              groups: _defineProperty({}, essentialGroupObj.id, essentialGroupObj.items.map(function (_ref2) {
                var id = _ref2.id;
                return id;
              }))
            } : {
              groups: currentDecision.consent
            };
            _iterator = _createForOfIteratorHelper(groups);
            _context.prev = 6;

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context.next = 32;
              break;
            }

            _step$value = _step.value, groupId = _step$value.id, items = _step$value.items;
            _iterator2 = _createForOfIteratorHelper(items);
            _context.prev = 11;

            _iterator2.s();

          case 13:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 22;
              break;
            }

            cookieId = _step2.value.id;

            if (!(cookies.indexOf(cookieId) > -1)) {
              _context.next = 20;
              break;
            }

            if (!(((_newConsent$groups$gr = newConsent.groups[groupId]) === null || _newConsent$groups$gr === void 0 ? void 0 : _newConsent$groups$gr.indexOf(cookieId)) > -1)) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("continue", 20);

          case 18:
            newConsent.groups[groupId] = newConsent.groups[groupId] || [];
            newConsent.groups[groupId].push(cookieId);

          case 20:
            _context.next = 13;
            break;

          case 22:
            _context.next = 27;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](11);

            _iterator2.e(_context.t0);

          case 27:
            _context.prev = 27;

            _iterator2.f();

            return _context.finish(27);

          case 30:
            _context.next = 8;
            break;

          case 32:
            _context.next = 37;
            break;

          case 34:
            _context.prev = 34;
            _context.t1 = _context["catch"](6);

            _iterator.e(_context.t1);

          case 37:
            _context.prev = 37;

            _iterator.f();

            return _context.finish(37);

          case 40:
            if (process.env.IS_TCF === "1" && isTcf) {
              tcfString = (_createTcfModelFromCo = createTcfModelFromCookie(tcf, tcfMetadata, getCookieConsentManager().getOption("tcfCookieName"))) === null || _createTcfModelFromCo === void 0 ? void 0 : _createTcfModelFromCo.tcfString;
            }

            _context.next = 43;
            return applyConsent({
              consent: newConsent,
              buttonClicked: "unblock",
              blocker: blockerId,
              blockerThumbnail: visualThumbnail !== null && visualThumbnail !== void 0 && visualThumbnail.embedId ? "".concat(visualThumbnail.embedId, "-").concat(visualThumbnail.fileMd5) : undefined,
              tcfString: tcfString
            });

          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 34, 37, 40], [11, 24, 27, 30]]);
  }));
  return _adjustConsentComingFromContentBlocker.apply(this, arguments);
}

export { adjustConsentComingFromContentBlocker };